import React from 'react';
import styles from './styles.module.scss';

export const Card = ({ children, onClick }) => (
  <div
    className={styles.card}
    onClick={onClick}
  >
    {children}
  </div>
);
